<template>
  <Layout :meta="dataMeta">
    <transition>
      <Jurusan :meta="dataMeta" :majors="majors" :contact="contact"></Jurusan>
    </transition>
  </Layout>
</template>
<script>
import broker from "@/utils/broker";

export default {
  props: ["dataMeta"],
  data() {
    return {
      majors: [],
      contact: {
        facebook: {},
        twitter: {},
        instagram: {},
        linkedin: {},
        youtube: {},
      },
    };
  },
  metaInfo() {
    return {
      title: `${this.dataMeta.name} - Sambutan`,
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  async mounted() {
    await this.getDataJurusan();
    await this.getSosialMedia();
  },
  methods: {
    async getDataJurusan() {
      await broker.fetch
        .get(`/webschool/content?types[]=majors&status=published`)
        .then((res) => {
          const data = res.data.data;
          this.majors = data.filter((o) => o.type.name === "majors");
        });
    },

    async getSosialMedia() {
      await broker.fetch
        .get(
          `/webschool/content?types[]=footer_desc&types[]=social_youtube&types[]=social_facebook&types[]=social_instagram&types[]=social_twitter&types[]=social_linkedin&status=published`
        )
        .then((res) => {
          const data = res.data.data;

          this.contact.facebook = data.find(
            (o) => o.type.name === "social_facebook"
          );
          this.contact.instagram = data.find(
            (o) => o.type.name === "social_instagram"
          );
          this.contact.twitter = data.find(
            (o) => o.type.name === "social_twitter"
          );
          this.contact.linkedin = data.find(
            (o) => o.type.name === "social_linkedin"
          );
          this.contact.youtube = data.find(
            (o) => o.type.name === "social_youtube"
          );
        });
    },
  },
  components: {
    Layout: () => import("@/components/template4/Layout"),
    Jurusan: () => import("./Jurusan"),
  },
};
</script>
<style lang="css">
@import "../../assets/css/template4/style-core.css";
@import "../../assets/css/template4/kingster-style-custom.css";
@import "../../assets/css/template4/page-builder.css";
@import "../../assets/css/template4/style.css";
</style>
